export const SEARCH_PARAMS = {
  commentsPage: 'commentsPage',
}

export const NUM_RESULTS_PER_PAGE = 5
